import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import userFeaturesReducer from "./userFeatureSlice";
import featureMenuReducer from "./featureMenuSlice";
import companyReducer from "./companySlice";

export const store = configureStore({
    reducer: {
        user: userReducer,
        userFeatures: userFeaturesReducer,
        featureMenu: featureMenuReducer,
        company: companyReducer,
    },
});
